import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const updateJobApplicant = (jobApplicantId: number, orgId: number, update: any) =>
  createGenericDispatcher({
    name: 'UPDATE_JOB_APPLICANT',
    loadFunction: () =>
      Api.post(`/application/${jobApplicantId}`, {
        body: JSON.stringify(update),
      }),
    args: { jobApplicantId, orgId, update },
  });
